<template>
  <div class="content">
    <el-form :model="formData" ref="formData" :rules="rules" label-width="120px" class="setting-form">
      <!-- 国家选择 -->
      <el-form-item>
        <span slot="label">
          <el-tooltip content="流量卡可以再那些国家使用" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
          限制使用国家
        </span>
        <div class="country-container">
          <el-radio v-model="formData.enableCountryLimit" label="00" >不设置</el-radio>
          <el-radio v-model="formData.enableCountryLimit" label="1" >开启</el-radio>
          <el-radio v-model="formData.enableCountryLimit" label="0" >不限制</el-radio>
          <div v-if="formData.enableCountryLimit === '1'" class="country-select">
            <el-select
              v-model="formData.countries"
              multiple
              filterable 
              placeholder="请选择可使用的国家"
            >
              <el-option
                v-for="item in countryOptions"
                :key="item.countryCode"
                :label="item.name+'['+item.englishName+']'"
                :value="item.countryCode"
              />
            </el-select>
          </div>
        </div>
      </el-form-item>

      <!-- 限速设置 -->
      <el-form-item label="限速设置">
        <span slot="label">
          <el-tooltip content="流量卡月总用量达到指定值时开始限速处理" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
          限速设置
        </span>
        <div class="speed-limit-container">
          <el-radio v-model="formData.enableSpeedLimit" label="00" >不设置</el-radio>
          <el-radio v-model="formData.enableSpeedLimit" label="1" >开启</el-radio>
          <el-radio v-model="formData.enableSpeedLimit" label="0" >关闭</el-radio>
          <div v-if="formData.enableSpeedLimit === '1'" class="speed-levels">
            <div class="speed-level-item">
              <el-select v-model="formData.speedLimitValue" placeholder="请选择限速值">
                <el-option
                  v-for="item in speedRuleData"
                  :key="item.id"
                  :label="item.name+' ' + item.lowSpeed +'Mbps'+ (!item.freeProductName?'':('  -  ' + item.freeProductName))"
                  :value="item.id">
                  <span style="float: left">{{ item.name }} <em style="color:red;font-weight:700">限速 {{ item.lowSpeed }}</em> Mbps ({{item.speedValue}})</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{!!item.freeProductName?'限速取消赠送':'无'}} {{ item.freeProductName }}</span>
                </el-option>
              </el-select>
            </div>
            <!-- <div v-for="(speed, index) in formData.speedLevels" :key="index" class="speed-level-item">
              <el-input-number 
                v-model="speed.value" 
                :min="1"
                :max="1000"
                size="small"
              />
              <span class="unit">Mbps</span>
              <el-button 
                type="text" 
                icon="el-icon-delete"
                @click="removeSpeedLevel(index)"
              />
            </div>
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-plus"
              @click="addSpeedLevel"
            >添加限速等级</el-button> -->
          </div>
        </div>
      </el-form-item>

      <el-form-item label="类型" prop="fieldType" >
        <el-radio v-model="formData.fieldType" label="1" >ICCID</el-radio>
        <el-radio v-model="formData.fieldType" label="2" >MSISDN</el-radio>
        <el-radio v-model="formData.fieldType" label="3" >文件上传</el-radio>
      </el-form-item>
      <el-form-item label="卡号范围" v-if="formData.fieldType != '3'">
        <el-row>
          <el-col :span="11">
            <el-form-item prop="iccidStart">
              <el-input
                v-model="formData.iccidStart"
                clearable
                placeholder="包含开始值"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="iccidEnd">
              <el-input
                v-model="formData.iccidEnd"
                clearable
                placeholder="包含终止值"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="卡号列表" prop="iccids" v-if="formData.fieldType != '3'">
        <el-input v-model="formData.iccids" type="textarea" placeholder="请输入批量卡号，每行只能输入一张卡号" rows="8" @input="handleCount">
        </el-input>
        <div><span>选中<em style="color:red">{{iccidCount}}</em>条</span></div>
      </el-form-item>
      <el-form-item label="Excel文件：" prop="file" v-if="formData.fieldType == '3'">
        <el-upload
          ref="upload"
          :limit="1"
          accept=".xlsx, .xls"
          action
          :auto-upload="true"
          :http-request="httpRequest"
          drag
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip text-center" style="text-align: left;" slot="tip">
            <span>仅允许导入xls、xlsx格式文件。</span>
            <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>
          </div>
        </el-upload>
      </el-form-item>

      <!-- 保存按钮 -->
      <el-form-item>
        <el-button type="primary" @click="saveSettings">保存设置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { batchCardSetting , listSpeedRule } from "@/api/api.js";
import { countryList } from "@/api/international.js";
export default {
  name: 'cardSetting',
  data() {
    return {
      formData: {
        enableCountryLimit: "00",
        countries: [],
        enableSpeedLimit: "00",
        speedLevels: [
          { value: 10 } // 默认一个限速等级
        ],
        speedLimitValue:"",
        fieldType:"1",
        iccidStart:'',
        iccidEnd:'',
        iccids:'',
      },
      speedRuleData:[],
      iccidCount:0,
      countryOptions:[],
      rules:{
				file: [
          { required: true,validator: this.checkFile, trigger: "blur" }
				],
        fieldType: [
          { required: true, message: "字段类型不能为空", trigger: "blur" },
        ],
			},
    };
  },
  computed: {
    cardIccids(){
      return this.$store.state.card.iccids;
    },
  },
  watch: {
    cardIccids(){
      this.handleIccids()
    }
  },
  methods: {
    handleIccids(){
      if(this.cardIccids){
        let arrIccids = this.cardIccids.split(",");
        this.formData.iccids = arrIccids.join("\n");
        this.fieldType = "1";
        this.iccidCount = arrIccids.length;
      }else{
        this.formData.iccids ='';
        this.iccidCount =0;
      }
    },
    httpRequest(param) {
      this.formData.file = param.file;
    },
    checkFile(rule, value, callback){
      if (!value) {
        return callback(new Error('请上传EXCEL文件'));
      }else{
        callback();
      }
    },
    handleCount(){
      let iccids = this.formData.iccids || "";
      let arr = iccids.split("\n").filter(v=>!!v);
      this.iccidCount = arr.length;
    },
    selectCountrys(){
      countryList().then(res=>{
        this.countryOptions = res.data.data
      })
    },
    selectSpeedRules(){
      listSpeedRule().then(res=>{
        this.speedRuleData = res.data.data
      })
    },
    addSpeedLevel() {
      this.formData.speedLevels.push({ value: 10 });
    },
    removeSpeedLevel(index) {
      this.formData.speedLevels.splice(index, 1);
    },
    saveSettings() {
      this.$refs.formData.validate(valid => {
        if(valid){
          let config = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };
          let formData = new FormData();
          formData.append("file", this.formData.file);
          formData.append("fieldType", this.formData.fieldType);
          formData.append("countries", this.formData.countries);
          formData.append("enableCountryLimit", this.formData.enableCountryLimit);
          formData.append("enableSpeedLimit", this.formData.enableSpeedLimit);
          formData.append("speedLimitValue", this.formData.speedLimitValue);
          formData.append("iccidStart", this.formData.iccidStart);
          formData.append("iccidEnd", this.formData.iccidEnd);
          formData.append("iccids", this.formData.iccids);
          batchCardSetting(formData, config).then(res => {
              this.$notify({
                title: "提示",
                message: "已提交卡导入，请在任务中心查看进度",
                type: "success",
                offset:30
              });
              this.resetFormData();
              this.$store.dispatch('ClearIccids')
              this.$refs.upload && this.$refs.upload.clearFiles()
              setTimeout(()=>{
                this.$router.push({ path: `/taskCenter/missionList`});
              },1000)
          })
        }
      })
    },
    resetFormData(){
      this.formData.enableCountryLimit = "00"
      this.formData.enableSpeedLimit = "00"
      this.formData.speedLimitValue = 1
      this.formData.countries =[]
      this.formData.fieldType = "1"
      this.formData.iccidStart = ""
      this.formData.iccidEnd = ""
      this.formData.iccids = ""
      this.iccidCount = 0
    },
    /**下载模板操作 */
    importTemplate() {
      this.download('/card/updateCardStatusTemplate', {
      }, `Template_${new Date().getTime()}.xlsx`)
    }
  },
  created(){
    this.selectCountrys()
    this.selectSpeedRules()
    this.handleIccids()
  }
};
</script>

<style scoped lang="less">
.setting-form {
  width: 700px;
  margin: 20px;
}

.country-container {
  .country-select {
    margin-top: 10px;
    
    .el-select {
      width: 100%;
    }
  }
}

.speed-limit-container {
  .speed-levels {
    margin-top: 10px;
  }

  .speed-level-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .el-select {
      width: 100%;
    }
    .unit {
      margin: 0 10px;
    }
  }
}
</style>